import * as mutationTypes from './mutation-types'
import api from '../api/check'

const Checks = {
  state() {
    return {
      checkLists: {},
      checks: {},
      checkins: {},
      addCheckinPendingForCheckId: null,
    }
  },

  getters: {
    checkById: (state) => (id) => {
      return state.checks[id]
    },

    checkListChecks: (state) => (ledgerId, checkListId) => {
      return state.checkLists[ledgerId][checkListId].checkIds.map(
        (checkId) => state.checks[checkId]
      )
    },

    checkCheckins: (state, getters) => (checkId) => {
      return getters
        .checkById(checkId)
        .checkinIds.map((checkinId) => state.checkins[checkinId])
    },

    checkinByUser: (state, getters) => (checkId, userId) => {
      const userCheckin = getters
        .checkCheckins(checkId)
        .find(
          (checkin) => checkin.userId === userId && checkin.anyUserId === null
        )
      if (userCheckin) {
        return userCheckin
      }
      const anyUserCheckin = getters
        .checkCheckins(checkId)
        .find((checkin) => checkin.anyUserId !== null)
      return anyUserCheckin
    },

    allChecks: (state) => {
      return state.checks
    },

    participantsByChecklist: (state) => {
      return Object.keys(state.checkLists).reduce((acc, ledgerId) => {
        const checkLists = state.checkLists[ledgerId]
        acc[ledgerId] = Object.keys(checkLists).reduce((acc2, checkListId) => {
          const checkList = checkLists[checkListId]
          const shouldCountAnyUser = checkList.allowAnyUser ? 1 : 0

          acc2[checkListId] =
            checkList.participantIds.length + shouldCountAnyUser
          return acc2
        }, {})
        return acc
      }, {})
    },
  },

  mutations: {
    [mutationTypes.SET_CHECK_LISTS](state, checkLists) {
      state.checkLists = checkLists
    },

    [mutationTypes.SET_CHECKS](state, checks) {
      state.checks = checks
    },

    [mutationTypes.SET_CHECKINS](state, checkins) {
      state.checkins = checkins
    },

    [mutationTypes.ADD_CHECKIN_PENDING](state, value) {
      state.addCheckinPendingForCheckId = value
    },

    [mutationTypes.ADD_CHECKIN](state, { checkin, check }) {
      check.checkinIds.push(checkin.id)
      state.checkins[checkin.id] = checkin
    },

    [mutationTypes.DELETE_CHECKIN](state, { checkin, check }) {
      const index = check.checkinIds.indexOf(checkin.id)

      check.checkinIds.splice(index, 1)
      delete state.checkins[checkin.id]
    },

    [mutationTypes.SET_CHECK_FOLLOWER_IDS](state, { check, followerIds }) {
      // TODO: Verify the need for this bad practise
      check.followerIds = followerIds
    },
  },

  actions: {
    async toggleCheckLinkFollow({ commit, getters }, id) {
      const response = await api.toggleFollow(id)
      commit(mutationTypes.SET_CHECK_FOLLOWER_IDS, {
        check: getters.checkById(id),
        followerIds: response.followerIds,
      })
    },

    async addCheckin({ commit, getters, state, rootGetters }, checkId) {
      if (state.addCheckinPendingForCheckId === checkId) {
        return
      }

      commit(mutationTypes.ADD_CHECKIN_PENDING, checkId)

      const check = getters.checkById(checkId)
      const params = [checkId]

      // Inbox context - there is a communicationItem selected, so use its companyId,
      // otherwise, fallback to current company ID (by not providing a specific one)
      if (rootGetters.communicationItem) {
        params.push(rootGetters.communicationItem.companyId)
      }

      const response = await api.createCheckIn(...params)

      commit(mutationTypes.ADD_CHECKIN, { checkin: response, check: check })
      commit(mutationTypes.ADD_CHECKIN_PENDING, null)
    },

    async deleteCheckin({ commit, getters, rootGetters }, checkId) {
      const check = getters.checkById(checkId)
      const userCheckin = getters.checkinByUser(
        checkId,
        parseInt(Silverfin.currentUserId())
      )
      const params = [checkId, userCheckin.id]

      // Inbox context - there is a communicationItem selected, so use its companyId,
      // otherwise, fallback to current company ID (by not providing a specific one)
      if (rootGetters.communicationItem) {
        params.push(rootGetters.communicationItem.companyId)
      }

      await api.deleteCheckIn(...params)

      commit(mutationTypes.DELETE_CHECKIN, {
        checkin: userCheckin,
        check: check,
      })
    },
  },
}

export default Checks
